/**
 * Cap storefront sample quantities at 5 before checkout.
 * Detects samples by product type (incl. color chips), "[Sample]" / trailing
 * " Sample" title, sample- handle, or sample-product tag.
 */
(function () {
  const MAX = 5;
  const SAMPLE_TITLE = /\[sample\]/i;
  const SAMPLE_TITLE_SUFFIX = /\bsample\s*$/i;
  const SAMPLE_HANDLE = /^sample-/i;
  const CHIP_TYPES = {
    "FAB GLOSS COLOR": true,
    "FAB MATTE COLOR": true,
    "NATURAL TERRACOTTA CHIP": true,
    "SPECIALITY TERRACOTTA CHIP": true,
    "COTTO COLOR CHIP": true,
  };

  function isSample(item) {
    if (!item) return false;
    const productType = String(item.product_type || "")
      .trim()
      .toUpperCase();
    if (productType === "SAMPLE") return true;
    if (CHIP_TYPES[productType] || /\bCHIP\b/.test(productType)) return true;
    const title = String(item.product_title || item.title || "");
    if (SAMPLE_TITLE.test(title) || SAMPLE_TITLE_SUFFIX.test(title.trim())) {
      return true;
    }
    if (SAMPLE_HANDLE.test(String(item.handle || ""))) return true;
    const tags = Array.isArray(item.tags)
      ? item.tags.join(",")
      : String(item.tags || "");
    return /(^|,)\s*sample-product\s*(,|$)/i.test(tags);
  }

  async function clampCart() {
    try {
      const response = await fetch("/cart.js", { credentials: "same-origin" });
      if (!response.ok) return;
      const cart = await response.json();
      const updates = {};
      for (const item of cart.items || []) {
        if (!isSample(item)) continue;
        if (Number(item.quantity) > MAX) updates[item.key] = MAX;
      }
      if (Object.keys(updates).length === 0) return;
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ updates }),
      });
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch {
      // Theme/network issues should never break the storefront.
    }
  }

  function boot() {
    clampCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!/quantity|updates/i.test(target.name || target.className || "")) return;
    clampCart();
  });

  document.addEventListener("cart:updated", clampCart);
  document.addEventListener("ajaxProduct:added", clampCart);
})();
